<template>
  <v-row class="py-10 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="6" LOGO>
          <v-card class="text-center py-5 elevation-2 align-center">
            <img v-if="site.logo" :src="site.logo" height="70" alt="">
            <span v-if="!site.logo" class="headline">{{site.name}}</span>
          </v-card>
        </v-col>
        
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0" v-if="confirmedAppointment">
        </v-col>
        <v-col cols="12" md="6" MENU v-if="confirmedAppointment">
          <v-card class="pa-0" :loading="loading">
            <v-bottom-navigation
              color="white"
              grow
              dark
              :value="1"
              v-model="navi"
              :app="$vuetify.breakpoint.mdAndDown?true:false"
              background-color="secondary"
              :class="`${arabic?'arFont':'enFont'} font-weight-bold`"
            >
              <v-btn large :value="1" class="font-weight-bold" @click="getView('booking')">
                <span>الحجز</span>
              </v-btn>
              <v-btn large :value="2" class="font-weight-bold" @click="getView('germany')">
                <span>المانيا</span>
              </v-btn>
              <v-btn large :value="3" class="font-weight-bold" @click="getView('program')">
                <span v-if="lead && lead.program_name">{{lead.program_name.ar}}</span>
              </v-btn>
              <v-btn large :value="4" class="font-weight-bold" @click="getView('aramcco')">
                <span>ارامكو</span>
              </v-btn>
              <v-btn large :value="5" class="font-weight-bold" @click="getView('costs')">
                <span>التكاليف</span>
              </v-btn>
            </v-bottom-navigation>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0" v-if="confirmedAppointment">
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="6" GERMANY v-if="!booking">
          <Content
            :loading="loading"
            :arabic="arabic"
            :view="view"
            :lead="lead"
            :confirmed="confirmedAppointment"
          />
        </v-col>

        <v-col cols="12" md="6" INVITATION v-if="booking">
          <v-card class="px-3" :loading="loading">
            <v-card-text v-if="confirmation">
              <v-row class="pa-0" v-if="lead">
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 font-weight-bold`">
                  مرحبا بك {{lead.name}} مجدداً
                </v-col>
                
                <v-col cols="12" md="12" class="pa-0 ma-0">
                  <v-card outlined color="primary">
                    <v-card-text>
                      <v-row class="pa-0 align-center" >
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} white--text py-0`">
                          <v-row class="pa-0">
                            <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} white--text py-0`">
                              بمناسبة مرور 10 سنوات على تأسيس شركة ارامكو في المانيا، تقدم الشركة لأول 20 ملتحق ببرنامج {{lead.program_name.ar}} العرض الاقوى ولمدة محدودة جداً، استفد الان من العروض والخصومات عبر الترشح للمقابلات الشخصية
                            </v-col>
                            <v-col cols="12" v-if="false" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} white--text py-0`">
                              تقدم الشركة دراسة اللغة الالمانية مجانا لجميع المستويات المطلوبة من الملتحقين
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" v-if="false" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} white--text py-0`">
                          <v-row class="pa-0" >
                            <img width="100%" src="/aa.png" alt="">
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-card outlined>
                    <v-card-text>
                      <v-row class="align-center">
                        <v-col cols="12" style="font-size:18px;line-height:2;font-weight:700;" :class="`${arabic?'arFont':'enFont'} text-right pa-0`">
                          يرجى اختيار موعد المقابلة المناسب لك بتوقيت {{candidate.country_name.ar}}
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} text-right pa-0`">
                          <v-radio-group v-model="selectedAppointment" hide-details>
                            <v-col cols="12" >
                              <v-row class="align-center">
                                <v-expansion-panels focusable flat tile>
                                  <v-expansion-panel  v-for="(main, m) in available_appointments" :key="'app'+m">
                                    <v-expansion-panel-header>
                                      <v-row class="align-center py-0">
                                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} text-right pa-2 py-0`">
                                          <v-chip label color="error" dark small class="mx-2">{{main.day_ar}}</v-chip>
                                          الموافق 
                                          <v-chip label color="grey" dark small class="mx-2">{{main.date}}</v-chip>
                                          <v-chip label color="grey" dark x-small class="mx-2" v-if="!main.appointments.length">تم حجز جميع المواعيد</v-chip>
                                        </v-col>
                                      </v-row>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-row class="align-center py-2" v-if="main.appointments.length">
                                        <v-col cols="3" :class="`pa-1`" v-for="(app, ss) in main.appointments" :key="'apo-'+ss">
                                          <v-radio :value="`${main.main_id}|${app}|${main.day}`" hide-details>
                                            <template v-slot:label>
                                              <v-row class="pa-0 text-right">
                                                <v-col cols="12" :class="`py-0`">
                                                  {{app.split('T')[1].split('.')[0]}}
                                                </v-col>
                                                <v-col cols="12" :class="`py-0`" style="font-size:9px;" v-if="false">
                                                  {{app.split('T')[0]}}
                                                </v-col>
                                              </v-row>
                                            </template>
                                          </v-radio>
                                        </v-col>
                                      </v-row>
                                      <v-row class="align-right py-2" v-if="!main.appointments.length">
                                        <v-col cols="12" :class="`pa-1 text-center`">
                                          <span :class="`${arabic?'arFont':'enFont'}`">جميع المواعيد في هذا اليوم تم حجزها</span>
                                        </v-col>
                                      </v-row>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                              </v-row>
                            </v-col>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          يرجى منك تأكيد حضورك في الموعد المحدد الذي قمت بأختياره
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`" v-if="!selectedAppointment">
                          <v-alert colored-border border="top" type="error" icon="close" elevation="2">
                            يرجى اختيار احد المواعيد المتاحة في الايام اعلاه
                          </v-alert>
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`" v-if="selectedAppointment">
                          <v-alert 
                            icon="verified"
                            colored-border
                            border="top"
                            type="success"
                            elevation="2"
                          >
                            <v-row class="align-center">
                              <v-col cols="12">
                                سيكون موعد المقابلة يوم
                                {{available_appointments.filter(x=>x.main_id == selectedAppointment.split('|')[0] && x.day == selectedAppointment.split('|')[2])[0].day_ar}}
                                الموافق
                                {{selectedAppointment.split('|')[1].split('T')[0]}}
                                في تمام الساعة
                                {{selectedAppointment.split('|')[1].split('T')[1].split('.')[0]}}
                                بتوقيت
                                {{candidate.country_name.ar}}
                              </v-col>
                              <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                                <v-btn 
                                  :class="`${arabic?'arFont':'enFont'}`" 
                                  block 
                                  large
                                  :loading="loading"
                                  @click="confirmAppointment()"
                                  color="primary">
                                  اضغط لتأكيد هذا الموعد
                                </v-btn>
                              </v-col>
                            </v-row>

                          </v-alert>
                        </v-col>
                        
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-row class="pa-0" v-if="confirmedAppointment && selectedAppointment && candidate">
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 font-weight-bold`">
                  شكرا لك {{candidate.name}} تم تأكيد موعد حضور المقابلة الخاص بك
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-card outlined>
                    <v-card-text>
                      <v-row class="align-center">
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          موعد المقابلة
                        </v-col>
                        <v-col cols="12" :class="`pa-0`">
                          يوم
                          <v-chip label color="error" dark small class="mx-2">{{available_appointments.filter(x=>x.main_id == selectedAppointment.split('|')[0] && x.day == selectedAppointment.split('|')[2])[0].day_ar}}</v-chip>
                          الموافق
                          <v-chip label color="error" dark small class="mx-2">{{selectedAppointment.split('|')[1].split('T')[0]}}</v-chip>
                          الساعة
                          <v-chip label color="error" dark small class="mx-2">{{selectedAppointment.split('|')[1].split('T')[1].split('.')[0]}}</v-chip>
                          بتوقيت
                          {{candidate.country_name.ar}}
                        </v-col>
                        <v-col cols="12" :class="`py-2`" style="font-size:12px;">
                          *الساعة {{confirmedDetails.berlin_time}} بتوقيت برلين
                        </v-col>
                        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="candidate.seminar.recording_url">
                          <v-btn color="success" large block @click="joinSeminarLink(candidate.seminar.recording_url)">متابعة تسجيل السيمينار</v-btn>
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          للأستفسار يمكنك التواصل معنا عبر ايميل 
                          <div style="font-weight:bold;color:blue;">care@aramccogermany.com</div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/q3rcDyY3aBo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="openLink('https://events.aramccogermany.com/')">انجازات ارامكو</v-btn>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" dark color="#FF0000" block @click="openLink('https://youtube.com/channel/UC4ymCRoAHZ3JBbjb2PE_GSw')">ارامكو يوتيوب</v-btn>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" dark color="#4267B2" block @click="openLink('https://www.facebook.com/aramccogermany')">ارامكو فيسبوك</v-btn>
                </v-col>
              </v-row>
              <v-row class="pa-0" v-if="confirmedAppointment && !selectedAppointment && candidate">
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 font-weight-bold`">
                  شكرا لك {{candidate.name}} تم تأكيد موعد حضور المقابلة الخاص بك
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-card outlined>
                    <v-card-text>
                      <v-row class="align-center">
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          موعد المقابلة
                        </v-col>
                        <v-col cols="12" :class="`pa-0`">
                          يوم
                          <v-chip label color="error" dark small class="mx-2">{{confirmedDetails.day_ar}}</v-chip>
                          الموافق
                          <v-chip label color="error" dark small class="mx-2">
                            {{confirmedDetails.appointment.date.split(' ')[0]}}
                          </v-chip>
                          الساعة
                          <v-chip label color="error" dark small class="mx-2">{{confirmedDetails.local_time}}</v-chip>
                          بتوقيت
                          {{candidate.country_name.ar}}
                        </v-col>
                        <v-col cols="12" :class="`py-2`" style="font-size:12px;" v-if="false">
                          *الساعة {{confirmedDetails.time}} بتوقيت برلين
                        </v-col>
                        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="confirmedDetails.appointment.join_url">
                          <v-btn color="success" large block @click="joinSeminarLink(confirmedDetails.appointment.join_url)">الدخول للموعد</v-btn>
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`" v-if="!confirmedDetails.appointment.join_url">
                          <v-alert type="info" :value="true">
                            سيتم ارسال رابط Zoom للدخول للمقابلة قبل موعد المقابلة بربع ساعة الى ايميلك، وكما سيظهر الرابط هنا ايضاً
                          </v-alert>
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          للأستفسار يمكنك التواصل معنا عبر ايميل 
                          <div style="font-weight:bold;color:blue;">care@aramccogermany.com</div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <iframe width="100%" height="315" :src="getLink()" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="openLink('https://events.aramccogermany.com/')">انجازات ارامكو</v-btn>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" dark color="#FF0000" block @click="openLink('https://youtube.com/channel/UC4ymCRoAHZ3JBbjb2PE_GSw')">ارامكو يوتيوب</v-btn>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" dark color="#4267B2" block @click="openLink('https://www.facebook.com/aramccogermany')">ارامكو فيسبوك</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        
        <v-col cols="12" md="6" LOGO>
          <v-card class="text-center py-5 elevation-2 align-center" color="primary" dark>
            <div style="font-size:12px;direction:ltr;">{{ footerdate }} &copy; {{company}}<sup>®</sup> <strong> | WEB</strong></div>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import {firebase, db, auth} from '@/fb'
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import Content from '@/components/Content'

export default {
  components: { Content },
  data() {
    return {
      loading:false,
      dialog:false,
      lead:null,
      interview:null,
      footerdate: new Date().toISOString().substr(0, 4),
      company:'ARAMCCO IN GERMANY',
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      email:null,
      day:null,
      conditions:null,
      invitation:false,
      confirmation:false,
      conditions_met:[],
      confirmDetails:false,
      confirmedAppointment:false,
      date:null,
      start_answer:false,
      old:false,
      appointments:[],
      candidate:null,
      available_appointments:null,
      selectedAppointment:null,
      confirmedDetails:null,
      navi:1,
      booking:true,
      germany:false,
      program:false,
      aramcco:false,
      costs:false,
      view:'booking',
    }
  },
  
  methods: {
    getView(view){
      this.booking = false
      this.germany = false
      this.program = false
      this.aramcco = false
      this.costs = false
      this[view] = true
      this.view = view
    },
    getLink() {
      let links = [
        'https://www.youtube.com/embed/LPefz6Q_hAo',
        'https://www.youtube.com/embed/9XA23N_gD-4',
        'https://www.youtube.com/embed/1hjwgC3B0ck',
        'https://www.youtube.com/embed/koUcqsDXIDc',
        'https://www.youtube.com/embed/3-gmf8lptYY',
      ]
      return links[getRandomInt(0, links.length)]
    },
    joinSeminarLink(url) {
      window.open(url, '_blank');
    },
    changeDetails(){
      this.confirmDetails = false
      this.conditions_met = []
      for (let i = 0; i < this.interview.conditions_to_check.split('|').length; i++) {
        this.conditions_met[i] = false
      }
      try {
        gtag('event', `edit_details${this.old ? '_alt' : ''}`);
      } catch (error) {
        console.log(error)
      }
    },
    scrollDown() {
      this.$vuetify.goTo(9999)
      try {
        gtag('event', `press_scroll_down${this.old ? '_alt' : ''}`);
      } catch (error) {
        console.log(error)
      }
    },
    started_answer() {
      try {
        if(!this.start_answer) {
          gtag('event', `started_answer${this.old ? '_alt' : ''}`);
          try {
            gtag('event', `${this.lead.country_name.en}_${this.lead.program_name.en}_${this.date}_started_answer${this.old ? '_alt' : ''}`);
          } catch (error) {
            console.log(error)
          }
          this.start_answer = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    openLink(path){
      try {
        gtag('event', `open_link${this.old ? '_alt' : ''}`);
      } catch (error) {
        console.log(error)
      }
      window.open(path, '_blank').focus();
    },
    async updateScore(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let max = Object.keys(this.conditions_met).length
        let trues = Object.values(this.conditions_met).filter(x=>x).length
        let score = parseInt(trues / max * 100)
        console.log(this.conditions_met, max, trues, score)
        let en_id = this.$route.params.en_id
        let old = this.$route.query && this.$route.query.email ? true : false
        let hasher = old ? 'updateScorebyhashemail' : 'updateScorebyhash'
        let r  = await axios.post(`https://aramccoonline.com/back/public/api/v1/${hasher}/${en_id}`, {score}, {headers}).then(x=>x.data)
        this.$emit('snackbarNotification', `تم التحديث بنجاح`, 'success')
        try {
          gtag('event', `add_details${this.old ? '_alt' : ''}`);
          if(score < 100) {
            gtag('event', `failed_score${this.old ? '_alt' : ''}`);
            gtag('event', 'failed_score_' + score);
            try {
              gtag('event', `${this.lead.country_name.en}_${this.lead.program_name.en}_${this.date}_failed_${score}${this.old ? '_alt' : ''}`);
            } catch (error) {
              console.log(error)
            }
          }
        } catch (error) {
          console.log(error)
        }
        
        this.confirmDetails = true
        this.loading = false
      })
    },
    async confirmAppointment() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(this.selectedAppointment)
        let en_id = this.$route.params.en_id
        let booked_appointment = this.selectedAppointment
        let old = this.$route.query && this.$route.query.email ? true : false
        let hasher = 'confirmbycandidatehash'
        let r  = await axios.post(`https://aramccoonline.com/back/public/api/v1/${hasher}/${en_id}`, {booked_appointment}, {headers}).then(x=>x.data)
        this.confirmedDetails = r
        this.$emit('snackbarNotification', `تم تأكيد الحضور بنجاح`, 'success')
        this.invitation = false
        this.confirmation = false
        this.confirmedAppointment = true
        try {
          gtag('event', `autoconfirm${this.old ? '_alt' : ''}`);
        } catch (error) {
          console.log(error)
        }
        try {
          gtag('event', `${this.lead.country_name.en}_${this.lead.program_name.en}_${this.date}_autoconfirm${this.old ? '_alt' : ''}`);
        } catch (error) {
          console.log(error)
        }
        this.loading = false
      })
    },
    getFormat(d){
      return format(d)
    },
    async saveEmail(){
      this.loading = true
      let p = {
        email:this.email
      }
      let en_id = this.$route.params.en_id
      let r  = await axios.post(`https://aramccoonline.com/back/public/api/v1/updatebyhash/${en_id}`, p, {headers}).then(x=>x.data)
      console.log(r)
      if(!r.error) {
        this.$emit('snackbarNotification', `تم التحديث بنجاح`, 'success')
      }
      this.loading = false
    },
    testEmail(){
      let a = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
      console.log(a)
      return a
    },
    async getLead() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        let old = this.$route.query && this.$route.query.email ? true : false
        this.old = old
        let hasher = 'hashonlinecandidate'
        let en_id = this.$route.params.en_id
        let s = await axios.get(`https://aramccoonline.com/back/public/api/v1/${hasher}/${en_id}`).then(x=>x.data)
        console.log(s)
        if(!s.error) {
          this.appointments = s.appointments
          this.candidate = s.candidate
          this.lead = s.candidate
          this.available_appointments = [].concat(...s.appointments.map(main=>{
            return main.local_appointments.map(sub=>{
              return {
                ...sub, main_id:main.id, duration:main.duration, number:main.number
              }
            })
          })).sort((a, b)=>{
            return new Date(a.date) - new Date(b.date)
          })
          console.log(this.available_appointments)
          if(s.candidate && s.candidate.booked_appointment) {
            this.invitation = false
            this.confirmation = false
            this.confirmedAppointment = true
            this.confirmedDetails = s.pending
            try {
              gtag('event', `reopen_confirmation${this.old ? '_alt' : ''}`);
            } catch (error) {
              console.log(error)
            }
          }
          if(s.candidate && s.candidate.email) {
            this.email = s.candidate.email
          }
          try {
            gtag('event', `${this.lead.country_name.en}_${this.lead.program_name.en}_${this.date}_open${this.old ? '_alt' : ''}`);
          } catch (error) {
            console.log(error)
          }
        }
        this.loading = false
      })
    },
    async getRoute(){
      return new Promise(async (res, rej)=>{
        let a = this.$route.name
        if(a == 'ensa') {
          this.invitation = true
          this.confirmation = false
        } else if (a == 'OnlineBooking') {
          this.invitation = false
          this.confirmation = true
        }
        res(a)
      })
    }
    
  },
  watch:{
  },
  computed:{
    
    checkIfFit() {
      let b = Object.values(this.conditions_met)
      let c = b.filter(x=> !x).length
      if(c > 0) {
        return false
      } else {
        return true
      }
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    goalModel(){
      return this.$store.state.goalModel
    },
    keyResultModel(){
      return this.$store.state.keyResultModel
    },
    initModel(){
      return this.$store.state.initiativeModel
    },
    units(){
      return this.$store.state.units
    },
    quarters(){
      return this.$store.state.quarters
    },
    fileTypes(){
      return this.$store.state.fileTypes
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.getRoute()
    await this.getLead()
  },
  
}
</script>

<style>
.forceLTR * {
  direction:ltr !important;
  text-align: left !important;
}
.forceLTR label {
  right:unset!important;
}
</style>